import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => {
  return {
    root: {
      maxWidth: '100%',
    },

    confirmList: {
      paddingLeft: 0,
      marginBottom: '0.75rem',
    },
    confirmHeader: {
      padding: '30px 20px 15px 3.75rem',
    },

    header: {
      display: 'block',
      padding: '1rem 0',
    },
    headerName: {
      marginBottom: '0.5rem',
      fontWeight: 'bold',
      display: 'block',
    },
    headerDisclaimer: {
      display: 'block',
      fontWeight: 'normal',
      color: theme.palette.warning.main,
    },
  };
});

export default useStyles;
